import { render, staticRenderFns } from "./indicator-form-tab2.vue?vue&type=template&id=32e34fe4&scoped=true&"
import script from "./indicator-form-tab2.vue?vue&type=script&lang=ts&"
export * from "./indicator-form-tab2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e34fe4",
  null
  
)

export default component.exports